"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const documentCreate = (0, graphql_tag_1.default)`
  ${data_1.userMiniPopupSchemaFields}
  mutation docs_page_doc_create($data: CreateDocumentInput!, $fileUuid: String!) {
    documents {
      create(data: $data, fileUuid: $fileUuid) {
        id
        name
        path
        mimetype
        dateCreated
        dateUpdated
        isDeleted
        dateDeletion
        isFavorite
        canEdit
        canDelete
        tags
        fileSize
        category {
          id
          isProtected
          name
        }
        editor {
          ...userMiniPopupSchemaFields
        }
      }
    }
  }
`;
exports.default = documentCreate;